import { render, staticRenderFns } from "./publicExSucces.vue?vue&type=template&id=bef5ed1c&scoped=true&"
import script from "./publicExSucces.vue?vue&type=script&lang=js&"
export * from "./publicExSucces.vue?vue&type=script&lang=js&"
import style0 from "./publicExSucces.vue?vue&type=style&index=0&id=bef5ed1c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bef5ed1c",
  null
  
)

export default component.exports